export default __webpack_public_path__ + "static/media/waste-water.ca85c25d.png";